import { DataSourceType } from '../../v-api';
import { DataSourceDependency } from '../interfaces';

export const DATA_SOURCE_DEPENDENCIES: DataSourceDependency = {
    'project.building.currentHeatingSystem.heatGeneratorType': [
        DataSourceType.HeatingSystemTypes,
        DataSourceType.HeatGeneratorEnergySources
    ],
    'project.building.currentHeatingSystem.energySource': [DataSourceType.HeatingSystemTypes],
    'project.building.currentHeatingSystem.installationConstructionYear': [DataSourceType.HeatingSystemTypes],
    'project.address.countryCode': [DataSourceType.HeatGeneratorEnergySources, DataSourceType.HeatingSystemTypes]
};
